<template>
    <div class="mobil-bottom">
      <span v-if="siteName">{{ siteName }}</span>
      <span>Copyright © 2021 {{ domain }}</span>
    </div>
</template>

<script>
    export default {
        name: "bottom",
        data (){
          return {
            'domain': ''
          }
        },
        props:[
          'siteName'
        ],
        created(){
          this.domain = document.domain
        }
    }
</script>

<style scoped>
  .mobil-bottom{
    margin-top: 1.84vw;
    height: 16.1vw;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items:center;
    justify-content: space-evenly;
    font-size: 3.45vw;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/train/bottom.vue